<template>
  <div>
    <div class="layoutContent">
      <!-- 头部 -->
      <layout-header></layout-header>
      <div class="mainContent">
        <!-- 内容 -->

        <!-- <div> -->
        <router-view :key="$route.fullPath"></router-view>
        <!-- </div> -->
      </div>
      <!-- 底部 -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>
<script>
import layoutHeader from "./header.vue";
import layoutFooter from "./footer.vue";

export default {
  name: "layout",
  components: {
    layoutHeader,
    layoutFooter,
  },
  data() {
    return {};
  },
};
</script>
<style scoped lang="less">
.layoutContent {
  width: 100%;
  @media (min-width: 1200px) {
    min-width: 1200px;
  }
  height: 100%;
  background: #eef4fc;
  .mainContent {
    min-height: calc(100vh - 300px - 60px - 140px);
  }
}
</style>